module.exports = __webpack_public_path__ + "static/media/find-icon-off.db2dbf8b.svg";